import DOMPurify from 'dompurify';

const CLINICAL_ALLOWED_TAGS = [
  'br', 'b', 'strong', 'i', 'em', 'u', 'p', 'span', 'div',
  'ul', 'ol', 'li', 'small', 'sub', 'sup', 'blockquote', 'hr',
] as const;

const PURIFY = {
  ALLOWED_TAGS: [...CLINICAL_ALLOWED_TAGS],
  ALLOWED_ATTR: [],
};

/** Sanitiza HTML de evoluções importadas (<br>, <b>, etc.) antes de usar em UI ou impressão. */
export function sanitizeClinicalHtml(raw: string | null | undefined): string {
  if (raw == null) return '';
  const s = String(raw);
  if (!s.trim()) return '';

  if (typeof window === 'undefined') {
    return s.replace(/<\s*\/?script[^>]*>/gi, '').replace(/\s*\bon\w+\s*=/gi, ' ');
  }

  return DOMPurify.sanitize(s, PURIFY);
}

/** Uma linha de pré-visualização sem tags HTML (listas / resumos na UI). */
export function clinicalHtmlToPlainPreview(raw: string | null | undefined, maxLen = 120): string {
  if (raw == null || !String(raw).trim()) return '';
  const withBreaks = String(raw)
    .replace(/<br\s*\/?>/gi, ' ')
    .replace(/<\/(?:p|div|li|tr|blockquote)>/gi, ' ')
    .replace(/<[^>]+>/g, '');
  const decoded = withBreaks
    .replace(/&nbsp;/gi, ' ')
    .replace(/&amp;/gi, '&')
    .replace(/&lt;/gi, '<')
    .replace(/&gt;/gi, '>')
    .replace(/&#(\d+);/g, (_, n) => {
      const code = Number(n);
      if (!Number.isFinite(code) || code < 1) return '';
      try {
        return String.fromCharCode(code);
      } catch {
        return '';
      }
    })
    .replace(/&#x([0-9a-f]+);/gi, (_, h) => {
      try {
        return String.fromCharCode(parseInt(h, 16));
      } catch {
        return '';
      }
    });
  const oneLine = decoded.replace(/\s+/g, ' ').trim();
  if (maxLen <= 0 || oneLine.length <= maxLen) return oneLine;
  return `${oneLine.slice(0, maxLen)}…`;
}
